<template>
    <v-container fluid>
        <Overlay />
        <v-row
            align="center"
            justify="center"
        >
            <v-col
                cols="12"
                lg="8"
                class="d-flex flex-row justify-space-between align-center"
            >
                <h1>Create Step</h1>
            </v-col>
        </v-row>

        <v-row
            align="start"
            justify="center"
            class="d-flex flex-row justify-center"
        >
            <v-col
                cols="12"
                md="8"
                align="center"
                justify="center"
            >
                <StepEditForm />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import StepEditForm from './StepEditForm';
import Overlay from '../../../../components/Overlay';
import { mapActions } from 'vuex';

export default {
    components: { Overlay, StepEditForm },

    mounted() {
        this.getData();
    },

    methods: {
        ...mapActions({
            showNotification: 'notification/show',
            getData: 'stepEditor/getData',
            saveData: 'stepEditor/saveData',
        }),
    }
};
</script>
